/**
 * Events related to player management
 */
export const events = {
  PLAYER_ADDED: 'player/added',
  PLAYER_REMOVED: 'player/removed',
  PLAYER_UPDATED: 'player/updated',
  SUBSTITUTION_MADE: 'player/substitution',
  GOALKEEPER_CHANGED: 'player/goalkeeper-changed',
  PLAYER_POSITION_CHANGED: 'player/position-changed'
};